import { useState, useEffect} from "react";
import {CommonDialogBox} from "components";
import { Box, Stack, DialogProps, InputLabel, Switch, FormControlLabel, Checkbox, ListItemText, Tooltip } from '@mui/material';
import Select from '@mui/material/Select';
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector} from 'react-redux';
import { closeVoxelTerrainDialog} from 'store/main/viewObjects';
import { RootState } from 'store';
import { styled } from "@mui/material/styles";
import { getCachedData } from "api/Cache";
import jwtService from 'services/jwtService';
import NotificationMsg from "panels/CreateProcessPanel/NotificationMsg";
import NotificationModel from 'components/notificationPanel/model/NotificationModel';
import { addNotification } from 'components/notificationPanel/store/dataSlice';
import { config } from "config";
import axios from 'axios';
import AuthService from "services/AuthService";
import {rawDataSources} from "constants/common";

import React from "react";

function VoxelTerrain(props:any){
    
    const org = config.org;
    //const org = useSelector((state: RootState) => state.auth.data.org);

    const {name} = props;
    const {project, catalogId, file_type, source_type, isFolder} = props;
    const dispatch = useDispatch();
    const data = getCachedData();

    const viewObject = useSelector((state: RootState) => state.main.viewObject);
    const SELECTED_RAWDATA = useSelector((state: RootState) => state.main.rawData.id);
    const { objSources, objType, vtstate:open } = viewObject;
    //console.log("objSources : " + JSON.stringify(objSources) + '............................')
    const [itemName, setItemName] = useState('New ' + name)
    const [itemNameError, setItemNameError] = useState(false)
    const [helperItemName, setHelperItemName] = useState('')
  
    const [checkedPC, setCheckedPC] = useState(false);
    const [checkedVT, setCheckedVT] = useState(false);
    const [source, setSource] = useState<string[]>([SELECTED_RAWDATA + '_' + source_type])
    const [sourceOrtho, setSourceOrtho] = useState([])
    const [classification, setClassification] = useState([])
    const [captureDate, setCaptureDate] = useState<any>(null)
    const [horizontalDatum, setHorizontalDatum] = useState('')
    const [verticalDatum, setVerticalDatum] = useState('')
    const [projections, setProjections] = useState('')
    const [horizontalUnits, setHorizontalUnits] = useState('')
    const [verticalUnits, setVerticalUnits] = useState('')
    const [fileDate, setFileDate] = useState('')

    const [coordOriginX, setCoordOriginX] = useState('')
    const [coordOriginY, setCoordOriginY] = useState('')
    const [coordOriginZ, setCoordOriginZ] = useState('')
    const [voxelSize, setVoxelSize] = useState('')
       
    const options = Array.from({ length: 30 }, (_, i) => `Point Classification ${i}`);
    const [selectedOptions, setSelectedOptions] = useState<String[]>(options);

    const closeComposeDialog: DialogProps["onClose"] = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;

        if(reason === "escapeKeyDown")
             cancel()
    }

	const cancel = () => {
        dispatch(closeVoxelTerrainDialog({}))
        setClassification([])
        setSource([])
        setCheckedPC(false)
        setCheckedVT(false)
        //setSelectedOptions([])
	}
 
    const handleName = (e:any) => {
        setItemName(e.target.value)
        if(e.target.value === ''){
            setItemNameError(true);
            setHelperItemName("Please select a name");
        }else{
            setItemNameError(false);
            setHelperItemName("");
        }
    }

    const handleChangePC = (event:any) => {
        setCheckedPC(event.target.checked);
    };

    const handleChangeVT = (event:any) => {
        setCheckedVT(event.target.checked);
    }; 
   
    const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
        "&:hover": {
            backgroundColor: "#1275aa", // light blue hover
            color: "#fff",
        },
        "&.Mui-selected": {
            backgroundColor: "#fff",
            position: "relative",
        },
        "&.Mui-selected:hover": {
            backgroundColor: "#1275aa",
            color: "#fff"
        },
        "&.Mui-selected::after": {
            content: '""',
            position: "absolute",
            right: 12,
            top: "50%",
            transform: "translateY(-50%)",
            width: 16,
            height: 16,
            backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='black' viewBox='0 0 24 24'><path d='M20.285 6.709l-11.285 11.293-5.285-5.293 1.41-1.41 3.875 3.879 9.875-9.879z'/></svg>")`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
        },
    }));

      
    
    const DialogAction = () => {
        return (
            <>
                <Button onClick={cancel}>Cancel</Button>
                <Button 
                    variant="contained"
                    color="primary"
                    type="submit" onClick={() => create()}
                    sx={{
                        '&.Mui-disabled': {
                            backgroundColor: (theme) => theme.palette.background.default,
                            color: (theme) => theme.palette.text.disabled,
                            opacity: '.75'
                        },
                    }}
                >
                    Create
                </Button>
            </>
        )
    }


    const create = async () => {
        
        //const ids = source.map(item => item.split("_")[0]);

        const payload = {
            name: itemName,
            source : source.map(item => item.split("_")[0]).join(" "),
            source_type : source.map(item => item.split("_")[1])[0],
            source_ortho : sourceOrtho.length > 0 ? sourceOrtho.join(" ") : "0", 
            normals : checkedPC ? 1 : 0,
            capture_date: Date.now().toString(),
            include_classification : selectedOptions.map(item => item.replace('Point Classification ', '')).join(" "),
            type: "FILE",
            state: "PARTIAL",
            file_type: file_type,
            file_size: "0",
            file_date: fileDate,
            file_folder: isFolder ? catalogId : "0",
            coord_origin_x: coordOriginX,
            coord_origin_y: coordOriginY,
            coord_origin_z: coordOriginZ,
            coord_hdatum: horizontalDatum,
            coord_vdatum: verticalDatum,
            coord_projection: projections,
            coord_projection_tm_falseEasting: "0",
            coord_projection_tm_falseNorthing: "0",
            coord_projection_tm_latOriginDeg: "0",
            coord_projection_tm_longMeridianDeg: "0",
            coord_projection_tm_scaleFactor: "0",
            coord_projection_lcc_falseEasting: "0",
            coord_projection_lcc_falseNorthing: "0",
            coord_projection_lcc_latOfOriginDeg: "0",
            coord_projection_lcc_longOfOriginDeg: "0",
            coord_projection_lcc_firstStdParallelDeg: "0",
            coord_projection_lcc_secondStdParallelDeg: "0",
            coord_projection_aeac_falseEasting: "0",
            coord_projection_aeac_falseNorthing: "0",
            coord_projection_aeac_latOfOriginDeg: "0",
            coord_projection_aeac_longOfOriginDeg: "0",
            coord_projection_aeac_firstStdParallelDeg: "0",
            coord_projection_aeac_secondStdParallelDeg: "0",
            coord_projection_amg_zone: "0",
            coord_unit: horizontalUnits,
            voxel_size: voxelSize
        }
        
        const response = await jwtService.fetchRequest({
			method: 'POST',
			url: `/entity.ashx?project=${project}`,
			data: payload,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
		});

		const data = response.data;

        if(data.result === 'success') {
            const id = data.id;
            const formData = new FormData();
		    formData.append("process", `IMPORT_${file_type}`);

            const response = await axios.post(`/events.ashx?project=${project}&id=${id}&org=${org}`, formData, {
                headers: { 
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${AuthService.getToken()}`,
                    },
                });

            if(response.data.result === 'success'){
                dispatch(addNotification(NotificationModel({ message: <NotificationMsg msg={itemName}/>, options: { variant: 'success' } })));
            }else{
                dispatch(addNotification(NotificationModel({ message: 'An error occurs during the process upload', options: { variant: 'error' } })));
            }
    }else{
        dispatch(addNotification(NotificationModel({ message: 'An error occurs during the process upload', options: { variant: 'error' } })));
    }
       
        setTimeout(() => {
            dispatch(closeVoxelTerrainDialog({}))
        }, 100);
    }

    const handleChange =  (event: any) => {
         const value = event.target.value as String[];
        // Check if the "Select All" value is toggled
        if (value.includes("Select All")) {
            if (selectedOptions.length === options.length) {
                setSelectedOptions([]); // Deselect all
            } else {
                setSelectedOptions(options); // Select all
            }
        } else {
            setSelectedOptions(value);
        }
    };

    useEffect(() => {     

        const projects: any = data["projects"][project];
        setCaptureDate(Date.now())
        if (projects && projects['coord_hdatum']) 
            setHorizontalDatum(projects['coord_hdatum'])
        if (projects && projects['coord_vdatum']) 
            setVerticalDatum(projects['coord_vdatum'])

        setProjections(projects['coord_projection'])
        setHorizontalUnits(projects['coord_unit'])
        setVerticalUnits(projects['coord_unit'])
        setFileDate(projects['file_date'])
        setCoordOriginX(projects['coord_origin_x'])
        setCoordOriginY(projects['coord_origin_y'])
        setCoordOriginZ(projects['coord_origin_z'])
        setVoxelSize(projects['voxel_size'])
    }, [selectedOptions, data, project, source])

    const projectFiles = objSources.filter(
        (item: any) => item.file_folder === "0" && (item.type === objType || item.type === 'RAWHM')
    );

    const folderItems = objSources
    .filter((item: any) => item.type === "FOLDER" && item.project === project)
    .flatMap((folder: any) => {
        const files = objSources.filter(
            (item: any) => item.file_folder === folder.id && (item.type === objType || item.type === 'RAWHM')
        );

        if (files.length === 0) return [];

        return [
            <MenuItem disabled key={`${folder.id}-header`}>
                {folder.name.toUpperCase()}
            </MenuItem>,
            ...files.map((file: any) => (
                <CustomMenuItem value={file.id + '_' + file.type} key={file.id}>
                    {file.name}
                </CustomMenuItem>
            )),
            <div style={{ margin:'5px 0', borderTop : '1px solid #ededed' }}></div>
        ];
    });

    // Combine folderItems and projectFiles
    const allMenuItems = [
        ...folderItems,
        ...(projectFiles.length > 0
            ? [
                <MenuItem disabled key="project-header">PROJECT CONTENTS</MenuItem>,
                ...projectFiles.map((file: any) => (
                    <CustomMenuItem value={file.id + '_' + file.type} key={file.id}>
                        {file.name}
                    </CustomMenuItem>
                )),
            ]
            : []),
    ];

    
    return (
		<>
            <CommonDialogBox
                classes={{
                    paper: 'm-24 rounded-8'
                }}
                open={open}
                handleClose={closeComposeDialog}
                fullWidth
                maxWidth="sm"
                subtitle1={`New ${name}`}
                titleh5=''
                dialogAction={objSources.filter((item:any) => (item.type === objType || item.type === 'RAWHM') && item.project === project).length > 0 ? <DialogAction /> : ''}
                displayScrollBar={true}
                maxHeight={600}
                helpLinkCode="project-objects-voxel-terrain"
                
            >
                {
                    objSources.filter((item:any) => (item.type === objType || item.type === 'RAWHM') && item.project === project).length > 0 ? 
                <Stack 
                    gap={1}
                >
                    <InputLabel id="itemName-label">Name</InputLabel>
                    <Tooltip title="A descriptive name for the new terrain entity." placement="top" arrow>
                    <TextField
                        id="itemName"
                        name="itemName"
                        error={itemNameError}
                        helperText={helperItemName}
                        value={itemName}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        inputProps={{
                            style: {
                              height: '5px',
                            },
                        }}
                        onChange={handleName}
                    /> 
                    </Tooltip>
                    <div></div>
                    <InputLabel id="voxsurf-select-pc-label">Source</InputLabel>
                    <Tooltip title="Select one or more Point Cloud or Heightmap entities to be used as the base for the terrain." placement="top" arrow>
                    <Select
                        required
                        margin="dense"
                        id="voxsurf-select-pc"
                        name="voxsurf-select-pc"
                        label="Source"
                        value={source}
                        multiple
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e:any) => setSource(e.target.value)}
                        sx={{
                                '& .MuiSelect-multiple': {
                               display: 'flex',
                                justifyContent: 'left',   // centers horizontally
                                textAlign: 'center',        // centers multiline text
                                alignItems: 'center',       // centers vertically
                                paddingLeft: '15px',
                                paddingRight: 0,
                                },
                                '& .MuiChip-root': {
                                height: '20px',
                                fontSize: '0.75rem',
                                margin: '2px',
                                },
                            }}
                    >
                        {
                            //objSources.filter((item:any) => item.type === objType && item.project === project).map((elem:any, index:any) => <CustomMenuItem value={elem.id} key={index}>{elem.name}</CustomMenuItem>)
                            allMenuItems
                        }
                    </Select>
                    </Tooltip> 
                    <div></div>
                    <InputLabel id="include_classification-label">Include</InputLabel>
                    <Tooltip title="Choose which point classifications to include in the terrain model. By default, all points are used." placement="top" arrow>
                        <Select
                            multiple
                            value={selectedOptions}
                            onChange={handleChange}
                            renderValue={(selected) => (selected as string[]).length > 1 ? (selected as string[]).length + ' items selected' : (selected as string[]).join(',')} 
                            >
                            <MenuItem value="Select All">
                                <Checkbox checked={selectedOptions.length === options.length} />
                                <ListItemText primary="Select All" />
                            </MenuItem>
                            {
                            options.map((option) => (
                                <MenuItem key={option} value={option}>
                                <Checkbox checked={selectedOptions.includes(option)} />
                                <ListItemText primary={option} />
                                </MenuItem>
                            ))}
                        </Select>
                    </Tooltip>
                    <div></div>
                    <InputLabel id="src-ortho-label">Ortho-imagery</InputLabel>
                    <Tooltip title="Select one or more Ortho-Imagery entities to be draped over the terrain. These can be aerial photos or computed textures." placement="top" arrow>
                        <Select
                            required
                            margin="dense"
                            id="src-ortho-pc"
                            name="src-ortho-pc"
                            label="SourceOrtho"
                            value={sourceOrtho}
                            multiple
                            type="txt"
                            fullWidth
                            color='primary'
                            variant="outlined"
                            onChange={(e:any) => setSourceOrtho(e.target.value)}
                        >
                            {
                                objSources.filter((item:any) => item.type === 'ORTHO' && item.project === project).length ? 
                                objSources.filter((item:any) => item.type === 'ORTHO' && item.project === project).map((elem:any, index:any) => <CustomMenuItem value={elem.id} key={index}>{elem.name}</CustomMenuItem>)
                                :
                                <CustomMenuItem value={0} key={1}>{"None"}</CustomMenuItem>
                            }
                        </Select>
                    </Tooltip>
                  
                    <div></div>
                    <Box sx={{ width: '100%' }}>
                        <Tooltip title="If selected, the system will use RGB values from point clouds (if available) to generate an Ortho-Imagery set automatically." placement="top" arrow>
                        <FormControlLabel
                            control={<Switch checked={checkedPC} onChange={handleChangePC} />}
                            label="Use point cloud colors"
                        />
                        </Tooltip>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <Tooltip title="Requests the system to generate a high-frequency elevation detail set in the form of a normal map, enhancing terrain realism." placement="top" arrow>
                        <FormControlLabel
                            control={<Switch checked={checkedVT} onChange={handleChangeVT} />}
                            label="Generate terrain normals"
                        />
                        </Tooltip>
                   </Box>
                </Stack>
                :
                <div style={{display:'flex', justifyContent:'center', alignItems: 'center', height: '40vh'}}>
                   {
                   `No "${rawDataSources[objType]}" data source found`
                    }
                </div>
                }
            </CommonDialogBox>
		</>
  	)
}

export default VoxelTerrain